import React from "react";
import { $t } from './i18n';

class Description extends React.Component {
  render() {
    const { message = {}, children, id } = this.props
    return (
      <section id={id}>
        <div className="content">
          <h2 className="section-title">{$t(message.title)}</h2>
          { children }
          { (message.desc || []).map(item => <p key={item} className="desc">{$t(item)}</p>) }
        </div>
      </section>
    );
  }
}

export default Description;
